<template>
  <div class="flex flex-col gap-4 mt-2 petsSection">
    <h3 class="text-t6">Har du husdjur? (T.ex. hund eller katt)</h3>
<!--    <RadioButton v-if="!!noPetOption"
      id="petNo"
      :label="noPetOption.name"
      name="hasPet"
      v-model="isChecked"
      :value="false"
      :preset="preset === false"
    />
    <RadioButton v-if="!!notStatedOption"
      id="petYes"
      label="Ja, jag har husdjur"
      name="hasPet"
      v-model="isChecked"
      :value="true"
      :preset="preset === true"
    />-->

<!--    <div v-if="isChecked == true" class="relative z-60">-->
      <SelectField
        class="md:max-w-80"
        ref="petSelector"
        id="key"
        placeholder=""
        label="Välj i listan"
        :floatingLabel="true"
        :options="petOptions.map(option => ({ label: option.name, value: option.value }))"
        v-model="pet"
        @change="emit"
      />
<!--    </div>-->
  </div>
</template>

<script>
import Checkbox from '@/components/ui/form/checkbox';
import RadioButton from '@/components/ui/form/radioAlt';
import Input from '@/components/ui/form/input';
import SelectField from '@/components/ui/form/select';

export default {
  components: {
    Input,
    RadioButton,
    Checkbox,
    SelectField
  },
  props: {
    value: {
      required: true,
      default: null,
      pet: null,
    },
  },
  data() {
    return {
      preset: null,
      text: '',
      isChecked: null,
      notStatedOption: null,
      noPetOption: null,
      isSelected: null
    };
  },
  computed: {
    petOptions() {
      return this.$store.getters.getPetOptions;
    },
  },
  methods: {
    emit() {
      if(this.pet) {
        this.$emit('update:pet', {
          pet: this.pet,
        });
        this.$emit('update:petsFieldIsValid', !!this.pet && this.pet!='notstated' );
      } else {
        this.$emit('update:pet', {
          pet: this.notStatedOption.value,
        });
        this.$emit('update:petsFieldIsValid', false);
       // else this.$emit('update:petsFieldIsValid', true);
      }
      this.$emit('input');
    },
  },

  watch: {
    /*isChecked(checked) {
      if (!checked || checked == 'no') {
        this.$emit('update:pet', this.noPetOption.value)
        this.$emit('update:petsFieldIsValid', true );
      } else {
        this.$emit('update:petsFieldIsValid', !!this.pet && this.pet!='notstated' );
      }

      this.emit();
    },*/
  },

  created() {
    this.$store.cache.dispatch('fetchPetOptions')
      .then(pets => {
        this.noPetOption = pets.find(x => !!x.pet_none);
        this.notStatedOption = pets.find(x => !!x.pet_notstated);
      }).finally(() => {
      this.text = typeof this.value === 'string' ? this.value : '';
      //this.isChecked = !!this.preset  ?? !!this.value;

      let temp = this.$store.getters.getErrorReportDraft;
      if (temp && temp.pet && temp.pet.pet && temp.pet.pet != "notstated") {
        this.preset = true;
        this.isChecked = true;
        this.pet = temp.pet.pet;
      } else if(temp && temp.pet && temp.pet.pet && temp.pet.pet == "notstated") {
        this.preset = false;
        this.isChecked = false;
      }
      else {
        this.$emit('update:petsFieldIsValid', false );
      }

    });

  },
};
</script>
